import axios from 'axios';
import * as MyCollections from "../services/MyCollections";
import * as CommonFunctions from "../services/CommonFunctions";
import { urlInvoiceFakturownia } from '../config';

export const createInvoice = (invoiceData, token) => {

    const {
        salesDocuments,
        purchaseDocuments,
        otherDocumentsNumber,
        overdueDocumentsNumber,
        bankStatements,
        clientPackage,
        allClientPackages,
        jobContracts,
        mandateContracts,
        appointedBoardMembers,
        premiumPersonnel,
        clientPackageForMonthOfInvoicing,
        additionalServices,
        isEndDateAfterOrEqualProvidedMonthPlusTwo,
        isSuspensionStartDateAfterProvidedMonthPlusTwo,
        discountDTOs
    } = invoiceData;

    const Vat = 1.23

    // Calculate totals
    const totalDocuments = salesDocuments + purchaseDocuments + otherDocumentsNumber + bankStatements + overdueDocumentsNumber;

    const monthIndex = (invoiceData.month + 1) % 12 + 1; // Przesunięcie o 2 miesiące do przodu
    const monthName = MyCollections.getMonthNameById(monthIndex.toString());
    const year = invoiceData.month >= 11 ? invoiceData.year + 1 : invoiceData.year;
    const currentDate = new Date(year, monthIndex - 1, 1);
    const initialPositions = [];

    if (isEndDateAfterOrEqualProvidedMonthPlusTwo && isSuspensionStartDateAfterProvidedMonthPlusTwo) {
        const paidInAdvanceTo = new Date(invoiceData.paidInAdvanceTo);

        if (!invoiceData.isPaidInAdvance || paidInAdvanceTo.getFullYear() < currentDate.getFullYear() ||
            (paidInAdvanceTo.getFullYear() === currentDate.getFullYear() &&
                paidInAdvanceTo.getMonth() < currentDate.getMonth())) {

            const new_position = {
                "name": clientPackageForMonthOfInvoicing === null
                    ? `obsługa księgowa - ${monthName} ${year} pakiet ${clientPackage.description}`
                    : `obsługa księgowa - ${monthName} ${year} pakiet ${clientPackageForMonthOfInvoicing.description}`,
                "tax": 23,
                "total_price_gross": clientPackageForMonthOfInvoicing === null
                    ? clientPackage.packagePrice * Vat
                    : clientPackageForMonthOfInvoicing.packagePrice * Vat,
                "quantity": 1,
                "quantity_unit": "szt"
            }
            initialPositions.push(new_position);
        }

        if (invoiceData.isFakturownia && invoiceData.fakturowniaPrice !== null && invoiceData.fakturowniaPrice > 0) {
            // Pobierz datę z invoiceData.fakturowniaPayableFrom (zakładając, że jest to string w formacie 'YYYY-MM-DD')
            const payableFromDate = new Date(invoiceData.fakturowniaPayableFrom);

            // Sprawdź warunek miesiąca i roku
            if (payableFromDate.getFullYear() < currentDate.getFullYear() ||
                (payableFromDate.getFullYear() === currentDate.getFullYear() &&
                    payableFromDate.getMonth() <= currentDate.getMonth())) {

                // Warunek jest spełniony - dodaj nową pozycję do initialPositions
                const new_position = {
                    "name": 'opłata za Fakturownia.pl',
                    "tax": 23,
                    "total_price_gross": invoiceData.fakturowniaPrice * Vat,
                    "quantity": 1,
                    "quantity_unit": "szt"
                };
                initialPositions.push(new_position);
            }
        }
    }
    if (clientPackage !== null) {
        let optimalPackage = clientPackage;

        // Inicjalizacja minCost z kosztem obecnego pakietu
        let minCost = clientPackage.packagePrice + Math.max(0, (totalDocuments - clientPackage.numberOfPackageDocuments) * clientPackage.documentPrice);

        // Przegląd wszystkich pakietów w poszukiwaniu najtańszej opcji
        for (let i = 0; i < allClientPackages.length; i++) {
            const pkg = allClientPackages[i];

            // Pomijanie pakietów tańszych niż obecny pakiet klienta
            if (pkg.packagePrice < clientPackage.packagePrice) {
                continue;
            }

            // Oblicz całkowity koszt z danym pakietem
            const costWithThisPackage = pkg.packagePrice + Math.max(0, (totalDocuments - pkg.numberOfPackageDocuments) * pkg.documentPrice);

            // Jeśli koszt z tym pakietem jest mniejszy, zaktualizuj minimalny koszt i optymalny pakiet
            if (costWithThisPackage < minCost) {
                minCost = costWithThisPackage;
                optimalPackage = pkg;
            }
        }

        const jobContractPrice = optimalPackage.jobContractPrice;
        const mandateContractPrice = optimalPackage.mandateContractPrice;
        const appointedBoardMembersPrice = optimalPackage.appointedBoardMembersPrice;
        const premiumPersonnelPrice = optimalPackage.premiumPersonnelPrice;

        if (optimalPackage.packagePrice !== clientPackage.packagePrice) {
            const new_position = {
                "name": `dopłata do pakietu ${optimalPackage.description} - ${MyCollections.getMonthNameById(invoiceData.month.toString())} ${invoiceData.year}`,
                "tax": 23,
                "total_price_gross": (optimalPackage.packagePrice - clientPackage.packagePrice) * Vat,
                "quantity": 1,
                "quantity_unit": "szt"
            };
            initialPositions.push(new_position);
        }

        if (totalDocuments > optimalPackage.numberOfPackageDocuments) {
            const new_position = {
                "name": `dodatkowe dokumenty ponad pakiet ${optimalPackage.description} - ${MyCollections.getMonthNameById(invoiceData.month.toString())} ${invoiceData.year}`,
                "tax": 23,
                "total_price_gross": (totalDocuments - optimalPackage.numberOfPackageDocuments) * optimalPackage.documentPrice * Vat,
                "quantity": totalDocuments - optimalPackage.numberOfPackageDocuments,
                "quantity_unit": "szt"
            };
            initialPositions.push(new_position);
        }

        if (jobContracts > 0) {
            const new_position = {
                "name": `obsługa kadrowa - umowa o pracę - ${MyCollections.getMonthNameById(invoiceData.month.toString())} ${invoiceData.year}`,
                "tax": 23,
                "total_price_gross": jobContracts * jobContractPrice * Vat,
                "quantity": jobContracts,
                "quantity_unit": "szt"
            };
            initialPositions.push(new_position);
        }

        if (mandateContracts > 0) {
            const new_position = {
                "name": `obsługa kadrowa - umowa zlecenie - ${MyCollections.getMonthNameById(invoiceData.month.toString())} ${invoiceData.year}`,
                "tax": 23,
                "total_price_gross": mandateContracts * mandateContractPrice * Vat,
                "quantity": mandateContracts,
                "quantity_unit": "szt"
            };
            initialPositions.push(new_position);
        }
        if (appointedBoardMembers > 0) {
            const new_position = {
                "name": `obsługa kadrowa - student/członek zarządu - ${MyCollections.getMonthNameById(invoiceData.month.toString())} ${invoiceData.year}`,
                "tax": 23,
                "total_price_gross": appointedBoardMembers * appointedBoardMembersPrice * Vat,
                "quantity": appointedBoardMembers,
                "quantity_unit": "szt"
            };
            initialPositions.push(new_position);
        }
        if (premiumPersonnel > 0) {
            const new_position = {
                "name": `Obsługa kadrowa Premium pracownika zatrudnionego na umowę o pracę - ${MyCollections.getMonthNameById(invoiceData.month.toString())} ${invoiceData.year}`,
                "tax": 23,
                "total_price_gross": premiumPersonnel * premiumPersonnelPrice * Vat,
                "quantity": premiumPersonnel,
                "quantity_unit": "szt"
            };
            initialPositions.push(new_position);
        }

        additionalServices.map(item => {
            if (item.serviceTypeId === 1) {
                const new_position = {
                    "name": 'bilans i RZiS na żądanie klienta',
                    "tax": 23,
                    "total_price_gross": item.quantity * clientPackage.balanceSheetOnRequest * Vat,
                    "quantity": item.quantity,
                    "quantity_unit": "szt"
                }
                initialPositions.push(new_position);
            }
            if (item.serviceTypeId === 11) {
                const new_position = {
                    "name": 'dodatkowe 2 godziny konsultacji',
                    "tax": 23,
                    "total_price_gross": item.quantity * clientPackage.additionalConsultation * Vat,
                    "quantity": item.quantity,
                    "quantity_unit": "szt"
                }
                initialPositions.push(new_position);
            }
            if (item.serviceTypeId === 21) {
                const new_position = {
                    "name": 'dodatkowa deklaracja ponad standard',
                    "tax": 23,
                    "total_price_gross": item.quantity * clientPackage.additionalDeclaration * Vat,
                    "quantity": item.quantity,
                    "quantity_unit": "szt"
                }
                initialPositions.push(new_position);
            }
            if (item.serviceTypeId === 31) {
                const new_position = {
                    "name": 'korekta deklaracji z powodu dostarczenia dokumentów po terminie',
                    "tax": 23,
                    "total_price_gross": item.quantity * clientPackage.correctionOfDeclaration * Vat,
                    "quantity": item.quantity,
                    "quantity_unit": "szt"
                }
                initialPositions.push(new_position);
            }
            if (item.serviceTypeId === 41) {
                const new_position = {
                    "name": "usługa dodatkowa: " + item.serviceDetails,
                    "tax": 23,
                    "total_price_gross": item.quantity * clientPackage.otherServices * Vat,
                    "quantity": item.quantity,
                    "quantity_unit": "szt"
                }
                initialPositions.push(new_position);
            }
            if (item.serviceTypeId === 51) {
                const new_position = {
                    "name": 'sprawozdanie finansowe',
                    "tax": 23,
                    "total_price_gross": item.quantity * clientPackage.finReportSmallClient * Vat,
                    "quantity": item.quantity,
                    "quantity_unit": "szt"
                }
                initialPositions.push(new_position);
            }
            if (item.serviceTypeId === 61) {
                const new_position = {
                    "name": 'sprawozdanie finansowe',
                    "tax": 23,
                    "total_price_gross": item.quantity * clientPackage.finReportMediumClient * Vat,
                    "quantity": item.quantity,
                    "quantity_unit": "szt"
                }
                initialPositions.push(new_position);
            }
            if (item.serviceTypeId === 71) {
                const new_position = {
                    "name": 'sprawozdanie finansowe',
                    "tax": 23,
                    "total_price_gross": item.quantity * clientPackage.finReportLargeClient * Vat,
                    "quantity": item.quantity,
                    "quantity_unit": "szt"
                }
                initialPositions.push(new_position);
            }
            if (item.serviceTypeId === 81) {
                const new_position = {
                    "name": 'pomoc w złożeniu SF do eKRS',
                    "tax": 23,
                    "total_price_gross": item.quantity * clientPackage.sfToKrsAssistance * Vat,
                    "quantity": item.quantity,
                    "quantity_unit": "szt"
                }
                initialPositions.push(new_position);
            }
            if (item.serviceTypeId === 91) {
                const new_position = {
                    "name": 'opłata za CIT estoński',
                    "tax": 23,
                    "total_price_gross": item.quantity * clientPackage.estonianCit * Vat,
                    "quantity": item.quantity,
                    "quantity_unit": "szt"
                }
                initialPositions.push(new_position);
            }
        })
    }


    if (discountDTOs) {
        discountDTOs.forEach((discount) => {

            const amount =
                discount.type === "DISCOUNT"
                    ? -Math.abs(discount.discountAmount)
                    : Math.abs(discount.discountAmount);

            const new_position = {
                name: discount.invoiceDescription,
                tax: 23,
                total_price_gross: amount * Vat,
                quantity: 1,
                quantity_unit: "szt"
            };

            initialPositions.push(new_position);
        });
    }

    const getPersonWordForm = (count) => {
        if (count === 1) return "osoba";
        const lastDigit = count % 10;
        if (count >= 10 && count <= 21) return "osób";
        if (lastDigit > 1 && lastDigit < 5) return "osoby";
        return "osób";
    }

    const getWWordForm = (month) => {
        if (month === 9) return "we";
        return "w";
    };

    const getDescription = () => {
        let descriptionParts = [];

        if (totalDocuments >= 0) {
            descriptionParts.push(`\u200B\n`);
            descriptionParts.push(`Dokumenty: ${totalDocuments} szt. ${getWWordForm(invoiceData.month)} ${MyCollections.getMonthNameByIdForInvoice(invoiceData.month.toString())} ${invoiceData.year}${overdueDocumentsNumber > 0 ? ` (w tym dokumenty dostarczone po terminie w liczbie: ${overdueDocumentsNumber} szt.)` : ""}\r\n\r\n`);
        }
        // if (jobContracts > 0) {
        //     descriptionParts.push(`- obsługa kadrowa umowa o pracę: ${jobContracts} ${getPersonWordForm(jobContracts)} ${getWWordForm(invoiceData.month)} ${MyCollections.getMonthNameByIdForInvoice(invoiceData.month.toString())} ${invoiceData.year}\r\n`);
        // }
        // if (mandateContracts > 0) {
        //     descriptionParts.push(`- obsługa kadrowa umowa o dzieło/zlecenie: ${mandateContracts} ${getPersonWordForm(mandateContracts)} ${getWWordForm(invoiceData.month)} ${MyCollections.getMonthNameByIdForInvoice(invoiceData.month.toString())} ${invoiceData.year}\r\n`);
        // }
        // if (appointedBoardMembers > 0) {
        //     descriptionParts.push(`- obsługa kadrowa student/członek zarządu: ${appointedBoardMembers} ${getPersonWordForm(appointedBoardMembers)} ${getWWordForm(invoiceData.month)} ${MyCollections.getMonthNameByIdForInvoice(invoiceData.month.toString())} ${invoiceData.year}\r\n`);
        // }
        // if (premiumPersonnel > 0) {
        //     descriptionParts.push(`- obsługa kadrowa Premium pracownika zatrudnionego na umowę o pracę: ${premiumPersonnel} ${getPersonWordForm(premiumPersonnel)} ${getWWordForm(invoiceData.month)} ${MyCollections.getMonthNameByIdForInvoice(invoiceData.month.toString())} ${invoiceData.year}\r\n`);
        // }

        descriptionParts.push(
            // "-------------------------\r\n" +
            // "KONTAKT Z NAMI:\r\n\r\n" +
            // "Księgowa/Księgowy\r\n" +
            // `–> ${invoiceData.accountantData}\r\n\r\n` +
            // "Kierownik Biura\r\n" +
            // "wystawianie faktur, korekty, sprawdzanie płatności:\r\n" +
            // "–> Magdalena Maślankiewicz, +48 794 452 777, platnosci@7pm.pl\r\n\r\n" +
            // "Opiekun Klienta od 9:00 do 17:00\r\n" +
            // "w sprawie bieżącej obsługi księgowej, zmiany w KRS, pytania, reklamacje:\r\n" +
            // "--> opiekun@7pm.pl,  +48  504 114 777\r\n\r\n" +
            "Jak działają faktury w 7PM?\r\n" +
            "https://youtu.be/yBFkBKZDOn8\r\n"
        );

        return descriptionParts.join("");
    };


    const json_params = {
        "invoice": {
            "kind": "vat_mp",
            "number": null,
            "sell_date": CommonFunctions.getCurrentDateForInvoice(0, invoiceData.month, invoiceData.year),
            "issue_date": CommonFunctions.getCurrentDateForInvoice(0, invoiceData.month, invoiceData.year),
            "payment_to": CommonFunctions.getCurrentDateForInvoice(7, invoiceData.month, invoiceData.year),
            "payment_type": "transfer",
            "place": "Warszawa",
            "seller_name": "7PM Ksi\u0119gowo\u015b\u0107 sp. z o.o.",
            "seller_person": "Miros\u0142aw P\u0142owiec",
            "seller_post_code": "00-517",
            "seller_street": "Marszałkowska 80/116",
            "seller_city": "Warszawa",
            "seller_country": "PL",
            "seller_tax_no": "7010456662",
            "seller_bank": "ING Bank Śląski S.A.",
            "seller_bank_account": "48 1050 1025 1000 0090 8292 3443",

            "buyer_name": invoiceData.companyWorkingName + " " + invoiceData.legalFormTypeDesc.toUpperCase(),
            "buyer_tax_no": invoiceData.clientNIP,
            "buyer_street": invoiceData?.clientAddress ? invoiceData.clientAddress.street : "",
            "buyer_post_code": invoiceData?.clientAddress ? invoiceData.clientAddress.postalCode : "",
            "buyer_city": invoiceData?.clientAddress ? invoiceData.clientAddress.city : "",
            "buyer_country": "PL",
            "gtu_codes": [
                "GTU_12"
            ],
            "description": getDescription(),
            "positions": initialPositions
        }
    };

    const endpoint = urlInvoiceFakturownia;

    return new Promise((resolve, reject) => {
        if (initialPositions.length > 0) {
            axios.post(endpoint, json_params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
                .then((response) => {
                    console.log('Invoice created! ' + response.data.number);
                    resolve(response.data.number); // Rozwiązanie obietnicy z numerem faktury
                })
                .catch((error) => {
                    console.error('Error:', error);
                    reject(error); // Odrzucenie obietnicy z błędem
                });
        } else {
            resolve(); // Rozwiązanie obietnicy, jeśli nie ma pozycji do utworzenia faktury
        }
    });

}
